export default __webpack_public_path__ + "static/media/Rank_top_nav_bar_bg2.74e92f79.png";